var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"widgets"},[_c('div',{staticClass:"widgets-wrapper"},[_c('PersonWidget',{attrs:{"title":"Inscriptions","period":"last_7days","class-name":"full"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a501b52","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/contacts/Dashboard.vue
// module id = 559
// module chunks = 0